import * as DateFns from "date-fns";

export const ico = DateFns.parseISO("2014-09-02T00:00:00.000Z");

export const londonHardFork = DateFns.parseISO("2021-08-05T12:33:42.000Z");

export const parisHardFork = DateFns.parseISO("2022-09-15T06:42:42Z");

export const mergeDateTime = parisHardFork;
